/* eslint no-param-reassign: ["error", { "props": false }] */
/* eslint guard-for-in: 0 */
/* eslint no-restricted-syntax: 0 */
// MERGE TWO JS OBJECTS
export default function(obj1, obj2) {
  if (obj2) {
    for (const key in obj2) {
      obj1[key] = obj2[key];
    }
  }
}
